// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatUpdateBody = {
  chatId: string;
  title?: string | null;
  photoMediaId?: string | null;
};

export type typeChatUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { chatId: string };
};

export type typeChatUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatUpdateBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    title: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    photoMediaId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatUpdateBody);
  }

  return async function postChatUpdate(
    payload: typeChatUpdateBody,
  ): Promise<typeChatUpdateOutput200 | typeChatUpdateOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatUpdate" failed before calling the network. #0cf15122513e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#0cf15122513e" },
        },
        data: null,
      } as typeChatUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/update`,
      httpMethod: "POST",
      options,
    })) as typeChatUpdateOutput200 | typeChatUpdateOutput400;
  };
}
